import PouchDB from 'pouchdb';

import { get, upsert } from './common';
import { getSalesforceConnection } from '../utils/getSalesforceConnection';
import { isUnauthorized } from '../utils/salesforce';

const USERS = 'XXSUsers';

const soql = 'SELECT Id, Name, Email, CountryCode, AgentNo__c, Phone FROM User';
const mapDataToInsert = (data) =>
  data.map((d) => ({
    ...d,
    _id: d.Id,
  }));

class Users {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  load = (callback) => get({ key: USERS, db: this.db, callback });

  save = (products, onSuccess) =>
    upsert(this.db, USERS, mapDataToInsert(products), onSuccess);

  fetchFromSalesforceAndSave = async ({ credentials, onSuccess, onError }) => {
    let retries = 0;

    const inner = async () => {
      if (retries === 5) {
        throw new Error('Max out retries');
      }
      try {
        let done = false;
        let finalData = [];
        let locator = '';
        const connection = await getSalesforceConnection(
          credentials,
          retries > 0
        );

        const data = await connection.queryAll(soql);
        finalData = [...finalData, ...data.records];
        done = data.done;
        locator = data.nextRecordsUrl;
        while (!done) {
          const moreData = await connection.queryMore(locator);
          finalData = [...finalData, ...moreData.records];
          locator = moreData.nextRecordsUrl;
          done = moreData.done;
        }

        this.save(finalData);
        onSuccess();
      } catch (error) {
        if (isUnauthorized(error)) {
          retries++;
          const data = await inner();
          return data;
        }
        onError(error);
      }
    };

    await inner();
  };
}

export default Users;
